import { Box } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BoxIcon = createLucideIcon(Box);
